<template>
  <span class="news-label" :class="modifier">{{ text }}</span>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `news-label`。お知らせ一覧の記事行（`news-item`）と詳細の見出し
 * （`news-detail_meta`）が同じマークアップで使う。
 *
 * 支給CSSの3種に対応する — `label-important`（緑地・`renewal/style.css:1340`）／
 * `label-news`（薄緑地・`:1344`）／`label-press`（`rgba(255,255,255,0.05)` ＝ ほぼ透過に緑枠・`:1348`）。
 * `.label-press` は第6便で支給CSSへ入ったので、`label-news` へ寄せる必要が無くなった。
 * 表記は支給に合わせる（`design-src/20260810/news/index.html:437,455,464`）。
 *
 * `.news-label` は `width: 49px` 固定（`renewal/style.css:1338`・SP は `11vw`）で、支給は
 * 「重要 / News / PRESS」の3つ前提。API の区分もこの3つ
 * （`obbs_api/src/app/Enums/News/NewsCategory.php` の `IMPORTANT` / `NEWS` / `PRESS`）。
 * **一番長い `PRESS` で PC の文字幅は 38.9px（余白の内側 39.0px）とほぼ余裕が無い**（実測）。
 * SP は `News` も `PRESS` も padding を食うが枠からは出ない。区分が増えるなら幅の見直しが要る。
 */
import type { NewsType } from '@/types/domains/index';
import { NEWS_CATEGORY_NAME } from '@/consts/NewsCategoryConst';

type Props = {
  category: NewsType.Category;
};
const props = defineProps<Props>();

const modifier = computed<string>(() => {
  switch (props.category) {
    case NEWS_CATEGORY_NAME.IMPORTANT:
      return 'label-important';
    case NEWS_CATEGORY_NAME.PRESS:
      return 'label-press';
    default:
      return 'label-news';
  }
});

/** API の `NEWS` は「News」、`PRESS` は「PRESS」で出す（支給の表記） */
const text = computed<string>(() => {
  switch (props.category) {
    case NEWS_CATEGORY_NAME.IMPORTANT:
      return '重要';
    case NEWS_CATEGORY_NAME.PRESS:
      return 'PRESS';
    default:
      return 'News';
  }
});
</script>
